import * as React from 'react';
import {FeedItemContextType} from "components/feed/FeedItem/FeedItem";


/*

replaces

h6 is the lowest level

replaces h1, h2, h3, h4 with a level based on the levelsDown parameter

 */

interface Props {
  content:string;
  offset:FeedItemContextType|number;
  className:string;
}

export const HeaderLevelCorrectedContent = (props:Props) => {

  let content = props.content?props.content:'';
  if(props.offset) {
    if (Number.isInteger(props.offset)) {
      content = shiftHeadingLevels(content, props.offset);
    } else if ('bundle-feed' === props.offset || 'bundle-conversation' === props.offset) {
      content = shiftHeadingLevels(content, 1, 0);
    } else if ('feed' === props.offset) {
      content = shiftHeadingLevels(content, 2);
    } else if ('full-post' === props.offset) {
      content = shiftHeadingLevels(content, 0,-1);
    } else if ('bundle-overview' === props.offset) {
      content = shiftHeadingLevels(content, 0,0);
    }
  }

  return ( <div className={props.className} dangerouslySetInnerHTML={{__html: content}}></div>);

}

/**
 * Shifts all <h1>–<h6> up or down by an integer offset
 *
 * offset = 1 → h1 → h2, h2 → h3, …
 *
 * offset = -1 → h2 → h1, etc.
 *
 * Levels are clamped to valid HTML (h1–h6)
 *
 * Preserves:
 *
 * attributes
 *
 * inner HTML
 *
 * capitalization
 *
 * Does not rely on the DOM (safe for server-side use)
 *
 * @param html
 * @param offset
 */
function shiftHeadingLevels(html, offset, levelClassIncrease?:number  ) {
  if (!Number.isInteger(offset)) return html;

  return html.replace(
    /<\/?h([1-6])\b([^>]*)>/gi,
    (match, level, attrs) => {
      const isClosing = match.startsWith("</");
      const oldLevel = parseInt(level, 10);
      const newLevel = Math.min(6, Math.max(1, oldLevel + offset));
      const levelClass = `level${oldLevel+(undefined!==levelClassIncrease?levelClassIncrease:1)}`;
      return `${isClosing ? "</" : "<"}h${newLevel}${attrs} class="${levelClass}">`;
    }
  );
}